import { useTranslations } from 'next-intl';

/**
 * Hook for getting the date parts of a date.
 * This hook utilises the next-intl library to get the date parts.
 * @param date - The date to get the parts of
 * @returns The date parts
 */
function useDateParts(date: Date) {
  const t = useTranslations('general.dates');
  const year = t('year', { date });
  const month = t('month', { date });
  const day = t('day', { date });
  const time = t('time', { date });
  const weekday = t('weekday', { date });
  return { year, month, day, time, weekday };
}

export { useDateParts };
